import React from "react";
import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL_HREF } from "@/lib/contact";
import { track } from "@/lib/analytics";
import { fadeUp, fadeUpStagger, IN_VIEW } from "@/lib/motion";

// IMPORTANT: keep these strings in sync with the FAQPage JSON-LD in /public/index.html.
const FAQS = [
  {
    q: "Quanto costa il carro attrezzi a Roma?",
    a: "Il costo del carro attrezzi a Roma dipende dalla distanza, dall'orario e dal tipo di intervento (traino, recupero auto incidentate, recupero moto). Forniamo sempre un preventivo chiaro e trasparente al telefono, senza costi nascosti. Chiama il 06 9763 6222 per un prezzo immediato.",
  },
  {
    q: "Quanto tempo impiegate ad arrivare?",
    a: "Operiamo H24 in tutta Roma e provincia con tempi di intervento molto ridotti. In zone come EUR, Ostia, Fiumicino, Tiburtina, Aurelia o Appia organizziamo l'arrivo del carro attrezzi più vicino alla tua posizione per ridurre l'attesa al minimo.",
  },
  {
    q: "Lavorate anche di notte e nei festivi?",
    a: "Sì, il nostro servizio di carro attrezzi e soccorso stradale è operativo 24 ore su 24, 7 giorni su 7, festività incluse. Notte, weekend, Ferragosto o Natale: chiamaci al 06 9763 6222 in qualsiasi momento.",
  },
  {
    q: "Accettate pagamenti con carta?",
    a: "Sì, accettiamo contanti e pagamenti con carta direttamente sul posto tramite POS mobili. Nessun pagamento anticipato richiesto.",
  },
  {
    q: "Recuperate auto in situazioni difficili come ribaltamenti, auto infossate o incastrate nella sabbia?",
    a: "Sì. Interveniamo anche in situazioni complesse: auto ribaltate o su un fianco dopo un incidente, veicoli infossati in terreno cedevole o fango, auto incastrate nella sabbia a Ostia, Fregene e Fiumicino, oppure ferme per blocco centralina o guasto elettronico. Descrivici la situazione al telefono e arriviamo con il mezzo giusto.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={IN_VIEW}
          variants={fadeUpStagger}
          className="text-center max-w-2xl mx-auto"
        >
          <motion.p variants={fadeUp} className="text-brand-orange text-xs sm:text-sm font-bold tracking-[0.35em] uppercase">— 06 / FAQ</motion.p>
          <motion.h2 variants={fadeUp} className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl text-navy tracking-tight leading-[1.02]">
            Risposte chiare, <span className="text-brand-orange italic">prima di chiamare</span>.
          </motion.h2>
        </motion.div>

        <Accordion type="single" collapsible className="mt-10 divide-y divide-border border border-border rounded-2xl bg-white" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="px-5 sm:px-7">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-bold text-navy text-base sm:text-lg hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-10 text-center">
          <p className="text-muted-foreground">Non trovi la risposta che cerchi?</p>
          <a
            href={PHONE_TEL_HREF}
            onClick={() => track.phoneCall("faq")}
            data-testid="faq-call-button"
            className="mt-3 inline-flex items-center gap-3 rounded-2xl bg-navy text-white px-6 py-4 font-bold hover:bg-brand-orange transition-colors"
          >
            <Phone className="h-5 w-5" />
            Chiama {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
